export const  Config = {
  // BotConfigAPI: "http://localhost:8000",
  BotConfigAPI: "https://api.beebot.bitsbee.net",
  UpbitAPI: "https://api.upbit.com",
  BinanceAPI: "https://api.binance.com",
  UiHost: "https://ui.bitsbee.io"
}
